import { Trans } from '@lingui/react/macro';

import HealthCheckError from './HealthCheckError';

type Props = {
  providerName: string;
};

const HealthCheckAPIAccessError = ({ providerName }: Props) => (
  <HealthCheckError
    title={
      <Trans>
        API Access Denied: The integration user does not have access to {providerName} or the
        permission set has been restricted.
      </Trans>
    }
  />
);

export default HealthCheckAPIAccessError;
